export const storeProcessTaskTypes = [
  'CLEANING',
  'RECEPTION',
  'INVENTORY',
  'CLIENT_RELATION',
] as const
export type StoreProcessTaskType = (typeof storeProcessTaskTypes)[number]

export const storeProcessTaskTypeLabel: Record<StoreProcessTaskType, string> = {
  CLEANING: 'Nettoyage',
  RECEPTION: 'Réception',
  INVENTORY: 'Inventaire',
  CLIENT_RELATION: 'Relation client',
}
